import firebaseApp from './../../utils/firebase/firebase';

import * as types from './historyActionTypes';
import {setUserPreviousAnswsers } from 'nm-react-quiz';

const newHistoryLine = (key, action, entity, created_at, points, value) => {
    return {
        type: types.RETRIEVE_HISTORY,
        key,
        action,
        entity,
        created_at,
        points,
        value
    }
}

const duplicateHistoryLine = () => {
    return {
        type: types.DUPLICATE_HISTORY
    }
}

export const retrieveHistory = (key, action, entity, created_at, points, value) => {
    return (dispatch, getState) => {

        let duplicate = false;
        let history = getState().history.history;
        for (var key=0; key<history.length; key++)
        {
            if(history[key].action === action && history[key].entity.entityId.toString() === entity.entityId.toString() ){
                duplicate = true;
            }
        }

        if(!duplicate)
        {
            // this action is dedicated only to the quizz component, it helps to rebuild the previous quizz's answer (based on history content)
            if(action==='answer'){
                //console.log('rebuild previous answser');
                const encodedValues = value.split('-');
                const answersMapping = [];
                if(encodedValues.length>1){
                    const correctsId = encodedValues[1].split(',');
                    const answersId = encodedValues[0].split(',');
                    
                    let answerFound = false;
                    for(let i=0; i < answersId.length; i++){
                        for(let j=0; j < correctsId.length; j++){
                            if(answersId[i]===correctsId[j]){
                                answerFound = true; 
                            }
                        }
                        answersMapping.push({'answer':answersId[i], 'valid':answerFound});
                    } 
                }
                dispatch(setUserPreviousAnswsers(entity.entityId, answersMapping));
            }
            dispatch(newHistoryLine(key, action, entity, created_at, points, value));
        }
        else {
            dispatch(duplicateHistoryLine());
        }
    }
}

export const destroyHistoryListeners = (userId) => {
    // unbind firebase listeners for History
    firebaseApp.database().ref(`users/${ userId }/history`).off();

    return {
        type: types.DESTROY_HISTORY
    }
}



// WEBPACK FOOTER //
// ./src/components/History/historyActions.js